// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Qz_z","validationTips":"StatementDescriptor_validationTips__3r05K"};